/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
  Route
} from 'react-router-dom'

import BlankLayout from 'Layouts/blank'

function CustomRoute({
  component: Component, layout: Layout = BlankLayout, ...rest
}) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  )
}

export default CustomRoute
